<template>
  <div>
    <base-nav
      v-model="showMenu"
      class="navbar-absolute top-navbar"
      type="white"
      containerClasses="container-fluid px-0"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper w-100 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="navbar-minimize d-inline d-lg-none"><sidebar-toggle-button /></div>
          <div class="navbar-toggle d-inline d-lg-none" :class="{ toggled: $sidebar.showSidebar }">
            <button v-if="isRootRoute" type="button" class="navbar-toggler" @click="toggleSidebar">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
            <button v-else type="button" class="navbar-toggler" @click="goBack">
              <p><i class="tim-icons icon-minimal-left"></i></p>
            </button>
          </div>
          <div class="navbar-brand text-truncate">{{ routeName }}</div>
        </div>
      </div>

      <audio ref="audioNotificacion" src="@/assets/audio/notificacion.mp3" preload="auto"></audio>

      <ul class="navbar-nav" :class="isRTL ? 'mr-auto' : 'ml-auto'">
        <div class="d-none d-lg-block">
          <Tema />
        </div>

        <base-dropdown
          v-if="LasNotificaciones"
          style="max-width: 90vw;"
          tag="li"
          :menu-on-right="!isRTL"
          title-tag="a"
          title-classes="nav-link"
          menu-classes="dropdown-black desktop-notif-dropdown mx-0"
          class="nav-item d-none d-lg-flex"
        >
          <template slot="title">
            <div :class="HayNotificacionClass"></div>
            <i class="fas fa-bell"></i>
          </template>

          <div class="dsk-notif-header">
            <div class="dsk-menu-icon dmi-blue"><i class="fas fa-bell"></i></div>
            <span class="dsk-notif-title">Notificaciones</span>
            <span class="dsk-notif-count" v-if="LasNotificaciones.length">{{ LasNotificaciones.length }}</span>
          </div>

          <div class="dsk-divider"></div>

          <Main-Cargando :cargando="CargaNoti">
            <div class="dsk-notif-list" @wheel.stop @touchmove.stop>
              <div
                v-for="(notificacion, index) in LasNotificaciones"
                :key="'dsk-notif-' + notificacion.id"
                class="dsk-notif-item"
              >
                <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" />
              </div>
              <div v-if="!LasNotificaciones.length" class="dsk-notif-empty">
                <i class="fas fa-check-circle"></i>
                <span>No hay notificaciones</span>
              </div>
            </div>
          </Main-Cargando>

          <div class="dsk-notif-footer" v-if="LasNotificaciones.length">
            <a href="#" @click.prevent="BorrarTodas" class="dsk-notif-footer-link">
              <i class="fas fa-check-double"></i> Marcar todas como leídas
            </a>
          </div>
        </base-dropdown>

        <base-dropdown
          tag="li"
          :menu-on-right="!isRTL"
          title-tag="a"
          class="nav-item d-none d-lg-flex"
          title-classes="nav-link"
          menu-classes="dropdown-black desktop-profile-dropdown"
        >
          <template slot="title">
            <div class="photo"><img :src="FotoURL" /></div>
            <b class="caret d-none d-lg-block d-xl-block"></b>
          </template>

          <div class="dsk-user-header">
            <div class="dsk-user-avatar">
              <img :src="FotoURL" />
            </div>
            <div class="dsk-user-info">
              <div class="dsk-user-name">{{ Nombre }}</div>
              <div class="dsk-user-role">{{ $SuscripcionesUsuarios.getEtiqueta() }}</div>
            </div>
          </div>

          <div class="dsk-divider"></div>

          <div class="dsk-section-label">CUENTA</div>
          <router-link to="/empleado/usuario" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-green"><i class="fas fa-user"></i></div>
            <span>Mi perfil</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </router-link>
          <router-link to="/empleado/comentarios" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-blue"><i class="fas fa-lightbulb"></i></div>
            <span>Comentarios</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </router-link>
          <a :href="soporteURL" target="_blank" class="dsk-menu-item">
            <div class="dsk-menu-icon dmi-teal"><i class="fas fa-headset"></i></div>
            <span>Soporte</span>
            <i class="fas fa-chevron-right dsk-menu-chevron"></i>
          </a>

          <div class="dsk-divider"></div>

          <template v-if="SuscripcionesUsuario && SuscripcionesUsuario.length">
            <div class="dsk-section-label">SUSCRIPCIONES</div>
            <a
              href="#"
              v-for="su in suscripcionesOrdenadas"
              :key="'dsk-sus-' + su.suscripcionID"
              class="dsk-company-item"
              :class="{ 'dsk-company-active': su.suscripcionID == suscripcionActualID }"
              @click.prevent="CambiaSuscripcion(su.suscripcionID)"
            >
              <div class="dsk-company-badge" :class="{ 'dsk-badge-active': su.suscripcionID == suscripcionActualID }">
                <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-check" style="font-size: 11px"></i>
                <template v-else>{{ su.suscripcion.etiqueta.charAt(0).toUpperCase() }}</template>
              </div>
              <div class="dsk-company-info">
                <div class="dsk-company-name">{{ su.suscripcion.etiqueta }}</div>
                <div class="dsk-company-role">{{ ObtenEtiquetaPerfil(su.perfilID) }}</div>
              </div>
              <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-circle dsk-company-active-dot"></i>
            </a>
            <div class="dsk-divider"></div>
          </template>

          <router-link to="/logout" class="dsk-menu-item dsk-logout-item">
            <div class="dsk-menu-icon dmi-red"><i class="fas fa-sign-out-alt"></i></div>
            <span>Cerrar sesión</span>
          </router-link>
        </base-dropdown>
      </ul>
    </base-nav>

    <transition name="mobile-panel-fade">
      <div class="mobile-backdrop" v-show="mobileMenuVisible" @click="closeMobileMenu"></div>
    </transition>

    <transition name="mobile-panel-slide">
      <div class="mobile-panel" v-show="mobileMenuVisible" ref="mobilePanel">
        <div class="mobile-panel-header">
          <div class="mobile-panel-user">
            <div class="mobile-panel-avatar">
              <img :src="FotoURL" />
            </div>
            <div class="mobile-panel-user-info">
              <div class="mobile-panel-user-name">{{ Nombre }}</div>
              <div class="mobile-panel-user-role">{{ $SuscripcionesUsuarios.getEtiqueta() }}</div>
            </div>
          </div>
          <button class="mobile-panel-close" @click="closeMobileMenu">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mobile-panel-section" v-if="LasNotificaciones && LasNotificaciones.length">
          <button class="mobile-section-toggle" @click="mobileNotifOpen = !mobileNotifOpen">
            <div class="mobile-section-toggle-left">
              <div class="mobile-menu-icon mi-bell"><i class="fas fa-bell"></i></div>
              <span>Notificaciones</span>
              <span class="mobile-notif-badge">{{ LasNotificaciones.length }}</span>
            </div>
            <i class="fas mobile-section-chevron" :class="mobileNotifOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <div class="mobile-notif-list" v-show="mobileNotifOpen">
            <Main-Cargando :cargando="CargaNoti">
              <div
                v-for="(notificacion, index) in LasNotificaciones"
                :key="'mob-notif-' + notificacion.id"
                class="mobile-notif-item"
              >
                <Notificacion v-model="LasNotificaciones[index]" @Actualizar="Actualiza" @abrir="closeMobileMenu" />
              </div>
            </Main-Cargando>
          </div>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section">
          <div class="mobile-section-label">CUENTA</div>
          <router-link to="/empleado/usuario" class="mobile-menu-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-green"><i class="fas fa-user"></i></div>
            <span>Mi perfil</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </router-link>
          <router-link to="/empleado/comentarios" class="mobile-menu-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-blue"><i class="fas fa-lightbulb"></i></div>
            <span>Comentarios</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </router-link>
          <a :href="soporteURL" target="_blank" class="mobile-menu-item" @click="closeMobileMenu">
            <div class="mobile-menu-icon mi-teal"><i class="fas fa-headset"></i></div>
            <span>Soporte</span>
            <i class="fas fa-chevron-right mobile-menu-chevron"></i>
          </a>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section">
          <div class="mobile-section-label">APARIENCIA</div>
          <div class="mobile-tema-wrap">
            <Tema />
          </div>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section" v-if="SuscripcionesUsuario && SuscripcionesUsuario.length">
          <div class="mobile-section-label">SUSCRIPCIONES</div>
          <a
            href="#"
            v-for="su in suscripcionesOrdenadas"
            :key="'mob-sus-' + su.suscripcionID"
            class="mobile-company-item"
            :class="{ 'mobile-company-active': su.suscripcionID == suscripcionActualID }"
            @click.prevent="CambiaSuscripcion(su.suscripcionID)"
          >
            <div class="mobile-company-badge" :class="{ 'badge-active': su.suscripcionID == suscripcionActualID }">
              <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-check" style="font-size: 12px"></i>
              <template v-else>{{ su.suscripcion.etiqueta.charAt(0).toUpperCase() }}</template>
            </div>
            <div class="mobile-company-info">
              <div class="mobile-company-name">{{ su.suscripcion.etiqueta }}</div>
              <div class="mobile-company-role">{{ ObtenEtiquetaPerfil(su.perfilID) }}</div>
            </div>
            <i v-if="su.suscripcionID == suscripcionActualID" class="fas fa-circle mobile-company-active-dot"></i>
          </a>
        </div>

        <div class="mobile-panel-divider"></div>

        <div class="mobile-panel-section mobile-section-logout">
          <router-link to="/logout" class="mobile-menu-item mobile-logout-item" @click.native="closeMobileMenu">
            <div class="mobile-menu-icon mi-red"><i class="fas fa-sign-out-alt"></i></div>
            <span>Cerrar sesión</span>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { BaseNav } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import Notificacion from './Notificacion';
import swal from 'sweetalert2';
import Tema from '@/Vistas/Main/Tema.comp.vue';

import Notificaciones from '@/api-services/notificaciones.service';
import Usuarios from '@/api-services/usuarios.service';
import SuscripcionesUsuarios from '@/api-services/suscripciones.usuarios.service';

export default {
  components: {
    SidebarToggleButton,
    BaseNav,
    Notificacion,
    Tema,
  },
  props: {
    FotoURL: {
      type: String,
      default: '/img/default-avatar.png',
      description: 'Contiene la url de la foto del usuario',
    },
    Nombre: {
      type: String,
      default: 'El Usuario',
      description: 'Contiene el nombre del usuario',
    },
    soporteURL: {
      type: String,
      default: 'https://support.eclock.com.mx/portal/es/kb/eclock',
      description: 'URL de Soporte Técnico',
    },
    SuscripcionesUsuario: Array,
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      isMobileView: false,
      LasNotificaciones: null,
      mobileNotifOpen: false,
      CargaNoti: false,
    };
  },
  computed: {
    mobileMenuVisible() {
      return this.showMenu && this.isMobileView;
    },
    suscripcionActualID() {
      return this.$SuscripcionesUsuarios.getSuscripcionID();
    },
    suscripcionesOrdenadas() {
      if (!this.SuscripcionesUsuario || !this.SuscripcionesUsuario.length) return [];
      const actualID = this.suscripcionActualID;
      const activa = this.SuscripcionesUsuario.filter((su) => su.suscripcionID == actualID);
      const otras = this.SuscripcionesUsuario.filter((su) => su.suscripcionID != actualID);
      return [...activa, ...otras];
    },
    HayNotificacionClass() {
      if (this.LasNotificaciones && this.LasNotificaciones.length > 0) return ' notification';
      return '';
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name || 'Inicio');
    },
    isRTL() {
      return false;
    },
    isRootRoute() {
      return ['/empleado', '/main/empleado'].includes(this.$route.path);
    },
  },
  watch: {
    $route() {
      this.closeMobileMenu();
    },
    mobileMenuVisible(open) {
      if (open) {
        this._savedScrollY = window.scrollY;
        document.documentElement.classList.add('mobile-menu-open');
      } else {
        document.documentElement.classList.remove('mobile-menu-open');
        window.scrollTo(0, this._savedScrollY || 0);
      }
    },
    LasNotificaciones() {
      this.CargaNoti = true;
      setTimeout(() => {
        this.CargaNoti = false;
      }, 500);
    },
  },
  mounted() {
    this.Actualizar();
    this.isMobileView = window.innerWidth < 992;
    this._handleResize = () => {
      this.isMobileView = window.innerWidth < 992;
    };
    window.addEventListener('resize', this._handleResize);
  },
  beforeDestroy() {
    if (this._handleResize) {
      window.removeEventListener('resize', this._handleResize);
    }
    document.documentElement.classList.remove('mobile-menu-open');
  },
  methods: {
    closeMobileMenu() {
      this.showMenu = false;
    },
    ObtenEtiquetaPerfil(PerfilID) {
      return SuscripcionesUsuarios.ObtenEtiquetaPerfil(PerfilID);
    },
    Actualiza(comp) {
      this.CargaNoti = true;
      Notificaciones.Actualiza(comp, (LasNotificaciones) => {
        this.LasNotificaciones = LasNotificaciones;
        setTimeout(() => {
          this.CargaNoti = false;
          this.LasNotificaciones = LasNotificaciones;
        }, 500);
      });
    },
    Actualizar() {
      Notificaciones.Obten(this, (LasNotificaciones, Sonido) => {
        this.LasNotificaciones = LasNotificaciones;
        if (Sonido && this.$refs.audioNotificacion) {
          this.$refs.audioNotificacion.play();
        }
      });
    },
    BorrarTodas() {
      if (!this.LasNotificaciones || !this.LasNotificaciones.length) return;
      this.CargaNoti = true;
      let pendientes = this.LasNotificaciones.length;
      let completadas = 0;
      this.LasNotificaciones.forEach((notif) => {
        Notificaciones.delete(this, notif.id, () => {
          completadas++;
          if (completadas >= pendientes) {
            this.Actualizar();
          }
        });
      });
    },
    CambiaSuscripcion(SuscripcionID) {
      if (SuscripcionID == this.suscripcionActualID) {
        this.closeMobileMenu();
        return;
      }

      SuscripcionesUsuarios.setSuscripcionID(SuscripcionID);
      Usuarios.getPerfilLocal(() => {}, true);
      this.closeMobileMenu();

      this.$nextTick(() => {
        swal
          .fire({
            title: 'Listo',
            text: 'Se ha cambiado la suscripción seleccionada.',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-fill',
            },
            buttonsStyling: false,
          })
          .then(() => {
            window.location.reload(false);
          });
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-navbar {
  top: 0px;
}

.navbar-nav {
  display: flex !important;
  align-items: center !important;
  gap: 4px;
}

::v-deep .nav-item {
  display: flex;
  align-items: center;
}

::v-deep .nav-link {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  font-size: 1.1rem;
}

::v-deep .nav-item .fas {
  font-size: 1.05rem;
  line-height: 1;
}

::v-deep .photo {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

::v-deep .desktop-profile-dropdown {
  min-width: 300px;
  padding: 0 !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: linear-gradient(180deg, #0d1426 0%, #111a2e 50%, #162038 100%) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
  overflow: hidden;
}

.dsk-user-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 18px 14px;
}

.dsk-user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  border: 2.5px solid #2ecc71;
  box-shadow: 0 0 12px rgba(46, 204, 113, 0.25);
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.dsk-user-info {
  min-width: 0;
}

.dsk-user-name {
  font-size: 15px;
  font-weight: 700;
  color: #f0f4ff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dsk-user-role {
  font-size: 10px;
  font-weight: 600;
  color: #2ecc71;
  margin-top: 3px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(46, 204, 113, 0.1);
  padding: 2px 8px;
  border-radius: 100px;
  border: 1px solid rgba(46, 204, 113, 0.15);
}

.dsk-section-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #5a6b85;
  padding: 10px 18px 4px;
}

.dsk-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 6px 16px;
}

.dsk-menu-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
  padding: 10px 18px !important;
  color: #f0f4ff !important;
  text-decoration: none !important;
  transition: background 0.15s;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    text-decoration: none !important;
  }

  span {
    flex: 1;
  }
}

.dsk-menu-chevron {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.15);
}

.dsk-menu-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;

  &.dmi-green {
    background: rgba(46, 204, 113, 0.12);
    color: #2ecc71;
  }

  &.dmi-blue {
    background: rgba(59, 158, 255, 0.1);
    color: #3b9eff;
  }

  &.dmi-teal {
    background: rgba(0, 188, 212, 0.1);
    color: #00bcd4;
  }

  &.dmi-red {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
  }
}

.dsk-company-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px;
  padding: 9px 18px !important;
  color: #f0f4ff !important;
  text-decoration: none !important;
  transition: background 0.15s;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    text-decoration: none !important;
  }
}

.dsk-company-badge {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(46, 204, 113, 0.08);
  border: 1px solid rgba(46, 204, 113, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #2ecc71;
  flex-shrink: 0;
  transition: all 0.2s;

  &.dsk-badge-active {
    background: linear-gradient(135deg, #2ecc71, #27ae60);
    border-color: #2ecc71;
    color: #fff;
    box-shadow: 0 0 10px rgba(46, 204, 113, 0.3);
  }
}

.dsk-company-active {
  background: rgba(46, 204, 113, 0.05);
  border-left: 3px solid #2ecc71;
  padding-left: 15px !important;
}

.dsk-company-active-dot {
  font-size: 6px;
  color: #2ecc71;
  flex-shrink: 0;
  filter: drop-shadow(0 0 4px rgba(46, 204, 113, 0.5));
}

.dsk-company-info {
  flex: 1;
  min-width: 0;
}

.dsk-company-name {
  font-size: 13px;
  font-weight: 500;
  color: #f0f4ff;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dsk-company-role {
  font-size: 10px;
  color: #2ecc71;
  margin-top: 1px;
}

.dsk-logout-item {
  color: #dc3545 !important;
  margin-bottom: 8px;

  span {
    color: #dc3545;
  }
}

::v-deep .desktop-notif-dropdown {
  min-width: 380px;
  max-width: 420px;
  padding: 0 !important;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: linear-gradient(180deg, #0d1426 0%, #111a2e 50%, #162038 100%) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
  overflow: hidden;
}

.dsk-notif-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 18px 14px;
}

.dsk-notif-title {
  font-size: 15px;
  font-weight: 700;
  color: #f0f4ff;
  flex: 1;
}

.dsk-notif-count {
  font-size: 11px;
  font-weight: 600;
  color: #3b9eff;
  background: rgba(59, 158, 255, 0.15);
  padding: 2px 10px;
  border-radius: 100px;
  border: 1px solid rgba(59, 158, 255, 0.2);
}

.dsk-notif-list {
  max-height: 50vh;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 4px 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}

.dsk-notif-item {
  margin-bottom: 4px;
}

::v-deep .desktop-notif-dropdown .dsk-notif-item .card {
  background: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 10px !important;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.07) !important;
  }

  h4,
  h5,
  p {
    color: #f0f4ff !important;
  }

  h5 small {
    color: #8a9ab5 !important;
  }

  a {
    color: #f0f4ff !important;
    text-decoration: none !important;
  }

  .fa-times {
    color: rgba(255, 255, 255, 0.3) !important;
    transition: color 0.15s;

    &:hover {
      color: #dc3545 !important;
    }
  }

  &.bg-success {
    background: rgba(46, 204, 113, 0.12) !important;
    border-color: rgba(46, 204, 113, 0.2) !important;
  }

  &.bg-danger {
    background: rgba(220, 53, 69, 0.12) !important;
    border-color: rgba(220, 53, 69, 0.2) !important;
  }
}

::v-deep .desktop-notif-dropdown .dsk-notif-item .dropdown-menu-ancho {
  width: 100% !important;
}

.dsk-notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 18px;
  color: #5a6b85;
  font-size: 13px;

  i {
    font-size: 24px;
    color: #2ecc71;
    opacity: 0.5;
  }
}

.dsk-notif-footer {
  padding: 12px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: center;
}

.dsk-notif-footer-link {
  color: #3b9eff !important;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none !important;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #5bb3ff !important;
    text-decoration: underline !important;
  }

  i {
    font-size: 11px;
  }
}

.modal.show {
  z-index: 1090 !important;
}

.mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1079;
}

.mobile-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 88vw;
  max-width: 380px;
  background: linear-gradient(180deg, #0d1426 0%, #111a2e 50%, #162038 100%);
  z-index: 1080;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.6);
  border-left: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10px;
  }
}

.mobile-panel-fade-enter-active,
.mobile-panel-fade-leave-active {
  transition: opacity 0.25s ease;
}

.mobile-panel-fade-enter,
.mobile-panel-fade-leave-to {
  opacity: 0;
}

.mobile-panel-slide-enter-active {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.mobile-panel-slide-leave-active {
  transition: transform 0.2s ease-in;
}

.mobile-panel-slide-enter,
.mobile-panel-slide-leave-to {
  transform: translateX(100%);
}

.mobile-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 20px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.mobile-panel-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-panel-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  border: 2.5px solid #2ecc71;
  box-shadow: 0 0 14px rgba(46, 204, 113, 0.25);
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.mobile-panel-user-name {
  font-size: 17px;
  font-weight: 700;
  color: #f0f4ff;
  line-height: 1.2;
}

.mobile-panel-user-role {
  font-size: 11px;
  font-weight: 600;
  color: #2ecc71;
  margin-top: 3px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(46, 204, 113, 0.1);
  padding: 2px 8px;
  border-radius: 100px;
  border: 1px solid rgba(46, 204, 113, 0.15);
}

.mobile-panel-close {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #7a8ba8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #f0f4ff;
  }
}

.mobile-panel-section {
  padding: 2px 0;
}

.mobile-section-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #5a6b85;
  padding: 12px 20px 6px;
}

.mobile-panel-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
  margin: 6px 20px;
  flex-shrink: 0;
}

.mobile-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #f0f4ff;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }
}

.mobile-section-toggle-left {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
}

.mobile-section-chevron {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.25);
  transition: transform 0.2s;
}

.mobile-notif-badge {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 100px;
  min-width: 22px;
  text-align: center;
  box-shadow: 0 0 8px rgba(46, 204, 113, 0.3);
}

.mobile-notif-list {
  padding: 6px 14px 10px;
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
  }
}

.mobile-notif-item {
  margin-bottom: 6px;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #f0f4ff !important;
  text-decoration: none !important;
  transition: background 0.15s;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    text-decoration: none !important;
  }

  span {
    flex: 1;
  }
}

.mobile-menu-chevron {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.15);
}

.mobile-menu-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;

  &.mi-green {
    background: rgba(46, 204, 113, 0.12);
    color: #2ecc71;
  }

  &.mi-blue {
    background: rgba(59, 158, 255, 0.1);
    color: #3b9eff;
  }

  &.mi-teal {
    background: rgba(0, 188, 212, 0.1);
    color: #00bcd4;
  }

  &.mi-bell {
    background: rgba(245, 166, 35, 0.1);
    color: #f5a623;
  }

  &.mi-red {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
  }
}

::v-deep .mobile-tema-wrap {
  .nav-item {
    padding: 0;

    .nav-link {
      padding: 12px 20px;
      gap: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #f0f4ff;
      transition: background 0.15s;

      &:hover {
        background: rgba(255, 255, 255, 0.04);
      }

      i {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;

        &.fa-sun {
          background: rgba(245, 166, 35, 0.1);
        }

        &.fa-moon {
          background: rgba(138, 43, 226, 0.1);
        }
      }

      p {
        display: inline-block !important;
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: #f0f4ff;
      }
    }
  }
}

.mobile-company-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  color: #f0f4ff !important;
  text-decoration: none !important;
  transition: background 0.15s;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    text-decoration: none !important;
  }
}

.mobile-company-badge {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(46, 204, 113, 0.08);
  border: 1px solid rgba(46, 204, 113, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #2ecc71;
  flex-shrink: 0;
  transition: all 0.2s;

  &.badge-active {
    background: linear-gradient(135deg, #2ecc71, #27ae60);
    border-color: #2ecc71;
    color: #fff;
    box-shadow: 0 0 12px rgba(46, 204, 113, 0.3);
  }
}

.mobile-company-active {
  background: rgba(46, 204, 113, 0.05);
  border-left: 3px solid #2ecc71;
  padding-left: 17px;
}

.mobile-company-active-dot {
  font-size: 6px;
  color: #2ecc71;
  flex-shrink: 0;
  filter: drop-shadow(0 0 4px rgba(46, 204, 113, 0.5));
}

.mobile-company-info {
  flex: 1;
  min-width: 0;
}

.mobile-company-name {
  font-size: 13px;
  font-weight: 500;
  color: #f0f4ff;
  line-height: 1.3;
  white-space: normal;
}

.mobile-company-role {
  font-size: 10px;
  color: #2ecc71;
  margin-top: 2px;
}

.mobile-logout-item {
  color: #dc3545 !important;

  span {
    color: #dc3545;
  }
}

.mobile-section-logout {
  padding-bottom: 24px;
}
</style>

<style lang="scss">
html.mobile-menu-open,
html.mobile-menu-open body {
  overflow: hidden !important;
  height: 100% !important;
  position: relative !important;
}

body.white-content {
  .dropdown-menu.dropdown-black {
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;

    .dropdown-item {
      color: #1e293b !important;
    }

    .dropdown-divider {
      border-color: rgba(0, 0, 0, 0.08);
    }

    &:before {
      color: #ffffff;
    }

    &:after {
      color: rgba(0, 0, 0, 0.1);
    }
  }

  .desktop-profile-dropdown,
  .desktop-notif-dropdown,
  .mobile-panel {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fc 50%, #f0f3f8 100%) !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
  }

  .mobile-panel {
    border-left: 1px solid rgba(0, 0, 0, 0.08) !important;

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1) !important;
    }
  }

  .dsk-user-name,
  .dsk-notif-title,
  .mobile-panel-user-name,
  .dsk-company-name,
  .mobile-company-name,
  .dsk-menu-item,
  .mobile-menu-item,
  .dsk-company-item,
  .mobile-company-item,
  .mobile-section-toggle {
    color: #1e293b !important;
  }

  .dsk-user-role,
  .mobile-panel-user-role,
  .dsk-company-role,
  .mobile-company-role {
    color: #2ecc71 !important;
    background: rgba(46, 204, 113, 0.08) !important;
    border-color: rgba(46, 204, 113, 0.15) !important;
  }

  .dsk-section-label,
  .mobile-section-label,
  .dsk-notif-empty {
    color: #94a3b8 !important;
  }

  .dsk-divider,
  .mobile-panel-divider {
    background: rgba(0, 0, 0, 0.06) !important;
  }

  .mobile-panel-header,
  .dsk-notif-footer {
    border-color: rgba(0, 0, 0, 0.06) !important;
  }

  .dsk-menu-item:hover,
  .mobile-menu-item:hover,
  .dsk-company-item:hover,
  .mobile-company-item:hover,
  .mobile-section-toggle:hover {
    background: rgba(0, 0, 0, 0.03) !important;
  }

  .dsk-menu-chevron,
  .mobile-menu-chevron,
  .mobile-section-chevron {
    color: rgba(0, 0, 0, 0.2) !important;
  }

  .desktop-notif-dropdown .dsk-notif-item .card {
    background: rgba(0, 0, 0, 0.02) !important;
    border: 1px solid rgba(0, 0, 0, 0.06) !important;

    &:hover {
      background: rgba(0, 0, 0, 0.04) !important;
    }

    h4,
    h5,
    p,
    a {
      color: #1e293b !important;
    }

    h5 small {
      color: #64748b !important;
    }

    .fa-times {
      color: rgba(0, 0, 0, 0.3) !important;

      &:hover {
        color: #dc3545 !important;
      }
    }
  }

  .mobile-panel-close {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: rgba(0, 0, 0, 0.03) !important;
    color: #64748b !important;
  }

  .mobile-panel-close:hover {
    background: rgba(0, 0, 0, 0.06) !important;
    color: #1e293b !important;
  }

  .mobile-notif-list {
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.08) !important;
    }
  }

  .mobile-tema-wrap {
    .nav-item .nav-link {
      color: #1e293b !important;

      &:hover {
        background: rgba(0, 0, 0, 0.03) !important;
      }

      p {
        color: #1e293b !important;
      }
    }
  }

  .mobile-logout-item,
  .dsk-logout-item {
    color: #dc3545 !important;

    span {
      color: #dc3545 !important;
    }
  }
}
</style>
